import React from 'react';
import SEO from '../components/layout/SEO';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import Testimonials from '../components/home/Testimonials';
import CTA from '../components/home/CTA';

const Home: React.FC = () => {
  return (
    <div>
      {/* Try to use the main SEO component, fallback to SimpleSEO if needed */}
      <SEO 
        title="tadriso LMS - Transform Education with Modern Learning Management"
        description="Empower educators, engage students, and streamline learning with our comprehensive LMS platform. Multi-role support, real-time analytics, and secure platform."
        keywords="LMS, learning management system, education technology, online learning, e-learning, CipherMind Technologies, student management, course management"
      />
      <Hero />
      <Features />
      <Testimonials />
      <CTA />
    </div>
  );
};

export default Home; 